<template>
	<div class="public-trends">
		<textarea v-model="content" class="content" placeholder="分享此刻......"></textarea>
		<UploadImg @uploadDelete="uploadDelete" @uploadSuccess="uploadSuccess"/>
		<div class="select">
			<el-form label-position="top">
				<el-form-item label="选择话题">
				    <el-select filterable @change="changeTalkPost"  v-model="talkId" placeholder="请搜索或选择话题">
				      <el-option v-for="(item,index) in talkList" :key="index" :label="item.categoryName" :value="item.id"></el-option>
				    </el-select>
				</el-form-item>
				<el-form-item label="选择圈子">
					<el-cascader
						:options="options"
						:props="{ value: 'id', label: 'value', checkStrictly: true, expandTrigger: 'hover' }"
						popper-class="circle-cascader-popper"
						v-model="selectedOptions"
						@change="handleChange">
					</el-cascader>
				</el-form-item>
			</el-form>
		</div>
		<div class="btns">
			<a @click="toCancel" href="javascript:;">取消</a>
			<a @click="publicClick" href="javascript:;" class="active">发布</a>
		</div>
	</div>
</template>

<script>
	import UploadImg from '@/components/upload'
	import postCateModules from '@/modules/postCategory.js'
	import { post, ajaxParam } from '@/units/request.js'
	import qs from 'qs'
	export default {
		name: 'publicTrends',
		components: {
			UploadImg
		},
		data() {
			return {
				userId: '',
				options: [],
        selectedOptions: [],
				content: '',
				uploadFileUrl: [],
				categoryId: '',
				circleId: '',
				circleList: [],
				circleClassifyId:'',
				talkId:'',
				talkList: [],
				title: '',
				postType: 1, //0文字动态1图片动态2视频动态
				postStatus: 1, // 0草稿，1发布
				picUrls: ''
			}
		},
		props: {
			item: {
				type: Object,
				value: ''
			}
		},
		mixins:[
			postCateModules
		],
		watch: {
			uploadFileUrl(newVal, oldVal){
				console.log('变')
				if(newVal.length>0){
					this.picUrls = newVal.join(',')
					console.log(this.picUrls)
				}
			}
		},
		created() {
			this.userId = localStorage.getItem('userId')||''

			this.getCircleCategory()
			this.getTalkList()
		},
		methods: {
			// 选择圈子
			handleChange(e){
				const len = this.selectedOptions.length
				// 三级级联：[分类ID, 圈子ID, 标签ID]，标签可选
				if (len >= 3) {
					this.circleId = this.selectedOptions[1]
					this.categoryId = this.selectedOptions[2]
				} else if (len === 2) {
					this.circleId = this.selectedOptions[1]
					this.categoryId = null
				} else {
					this.circleId = null
					this.categoryId = null
				}
			},
			toCancel(e){
				this.$emit('toCancel')
			},
			uploadSuccess(e){
				console.log('success')
				console.log(e.uploadFileList)
				this.uploadFileUrl = e.uploadFileList
			},
			uploadDelete(e){
				let a = []
				e.uploadFileList.forEach(item=>{
					a.push(item.response.entity.fileUrl)
				})
				this.uploadFileUrl = a
			},
			changeTalkPost(e){
				this.talkId = e
				console.log(e)
			},
			//获取圈子父级分类
			
			// 获取圈子三级列表
			async getCircleCategory(){
				let param = {
					userId: this.userId
				}
				ajaxParam(param)
				const res = await post('v1/circle/joinCircleThreeLevel', qs.stringify(param))
				if(res.data.code==200){
					this.options = res.data.list
				} else {
					this.$message.error(res.data.msg)
				}
			},
			//获取加入圈子话题
			async getTalkList(){
				let param = {}
				ajaxParam(param)
				const res = await post('v1/circle/circlePostTalk', qs.stringify(param))
				if(res.data.code==200){
					this.talkList = res.data.list
				} else {
					this.$message.error(res.data.msg)
				}
			},
			//发布
			async publicClick(){
				if(!this.content) {
					this.$message.error('请输入发布内容')
					return
				}
				if(!this.circleId) {
					this.$message.error('请选择圈子')
					return
				}
				let param = {
					userId: this.userId,
					talkId:this.talkId,
					picUrls: this.picUrls,
					content: this.content,
					postType: this.postType,
					categoryId: this.categoryId,
					circleId: this.circleId,
					postStatus: this.postStatus
				}
				console.log(param)
				ajaxParam(param)
				const res = await post('v1/circle/addPost', qs.stringify(param))
				if(res.data.code==200){
					this.$message.success(res.data.msg||'操作成功!')
					this.$emit('toCancel')
					this.$router.push({
						path: '/publicManage'
					})
				} else {
					this.$message.error(res.data.msg)
				}
			}
		}
	}
</script>

<style scoped lang="less">
	::v-deep .el-form--label-top .el-form-item__label{
		padding:0;
	}
	.public-trends{
		margin-top: -20px;
	}
	.content{
		width: 100%;
		height: 160px;
		margin-bottom: 15px;
		padding: 10px;
		border-color: #DBDCDC;
		box-sizing: border-box;
		border-radius: 4px;
	}
	/deep/ .el-upload-list--picture-card .el-upload-list__item,
	/deep/ .el-upload--picture-card {
		width: 70px;
		height: 70px;
		line-height: 70px;
	}
	.select{
		.el-form{
			display: flex;
			justify-content: space-between;
			.el-form-item{
				flex: 1;
				/deep/ .el-form-item__content{
					line-height: 30px;
				}
				/deep/ .el-input__inner{
					height: 30px;
					line-height: 30px;
				}
				/deep/ .el-input__icon{
					line-height: 30px;
				}
			}

		}
	}
	.btns{
		display: flex;
		justify-content: space-between;
		a{
			display: block;
			width: 45%;
			height: 34px;
			margin-left: 15px;
			background: rgba(50,50,50,.1);
			border-radius: 16px;
			line-height: 34px;
			text-align: center;
		}
		a:hover, a.active{
			background: #DD0515;
			color: #fff;
		}
	}
</style>

<style lang="less">
/* 圈子级联选择器交互优化 */
.circle-cascader-popper .el-cascader-node {
	position: relative;
}
/* 点击节点任意位置（含文字）等同点击单选按钮，圆圈和文字保持原位 */
.circle-cascader-popper .el-cascader-node .el-radio::after {
	content: '';
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	z-index: 10;
	cursor: pointer;
}
/* 选中路径上的父级节点高亮，表示已包含在选中路径中 */
.circle-cascader-popper .el-cascader-node.in-checked-path:not(.is-active) {
	color: #DD0515;
	font-weight: 600;
}
</style>
